// extracted by mini-css-extract-plugin
module.exports = {"visibleOnDesktop":"Header_visibleOnDesktop__5fatk","visibleOnMobile":"Header_visibleOnMobile__X5xbY"};